export const TITLE_BACKEND = "Backendnutzer";
export const TITLE_APP = "App Nutzer";
export const ADD_USER = "Nutzer hinzufügen";
export const USERNAME = "Nutzername";
export const PASWORD = "Passwort";
export const EMAIL = "Email";